var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredRightColumn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 9.5,
    fill: "#FF5C5C",
    fillOpacity: 0.5,
    stroke: "#FF5C5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9L23 22",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9L9 22",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredRightColumn);
export default __webpack_public_path__ + "static/media/expiredRightColumn.0ddd591382526458ff2a52259342d52a.svg";
export { ForwardRef as ReactComponent };